(function () {
  function bindSearchDrawerTriggers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.search-button, .js-drawer-open-search-link');
      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (window.wetheme && typeof window.wetheme.toggleRightDrawer === 'function') {
        window.wetheme.toggleRightDrawer('search', true);
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('wetheme-toggle-right-drawer', {
          detail: { type: 'search', forceOpen: true }
        })
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSearchDrawerTriggers);
  } else {
    bindSearchDrawerTriggers();
  }
})();
